import { formatParsedAvailableTimePeriodToAvailableTimePeriod } from "../../../utils/formatParsedAvailableTimePeriodToAvailableTimePeriod";

/**
 * get schedule sorted by ascending start date
 */
export function getAscendingSchedule(timePeriods: ParsedAvailableTimePeriod[]) {
  // sort by start date, ascending
  return timePeriods
    .map(formatParsedAvailableTimePeriodToAvailableTimePeriod)
    .sort((a, b) =>
      a.start_date === b.start_date ? 0 : a.start_date > b.start_date ? 1 : -1,
    );
}
